import {useEffect, useState} from 'react';
import {TextField, Typography, IconButton, MenuItem} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import DateRangePicker from '../Common/DateTimeRangePicker';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: theme.spacing(3)
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dateSelectBetween : {
        alignSelf: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    dateRangeRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        alignItems: 'center'
    }
}));

export default function PickupSearch(props) {
    const classes = useStyles();
    const {t} = useTranslation('driverPickup');

    const {onSearchClick,type} = props

    let pickupPartners = useSelector(state => state.driverPickupReducer.getPickupPartners);
    let pickupWarehouses = useSelector(state => state.driverPickupReducer.getPickupWarehouses);

    const searchTypeList = [
        {
            id: 0,
            text: t('date_range')
        },
        {
            id: 1,
            text: t('partner_id')
        },
        {
            id: 2,
            text: t('creator')
        },
        {
            id: 3,
            text: t('driver_id')
        }
    ]

    const [dateFrom, setDateFrom] = useState(moment());
    const [dateTo, setDateTo] = useState(moment());
    const [partnerId, setPartnerId] = useState(null);
    const [pickupWarehouse, setPickupWarehouse] = useState(`-1`)
    const [creator, setCreator] = useState(null);
    const [driverId, setDriverId] = useState(null);
    const [searchType, setSearchType] = useState(0);

    const handleDriverIdChange = (event) => {
        setDriverId(event.target.value);
    }
    const handleCreatorChange = (event) => {
        setCreator(event.target.value);
    }
    const handlePickupWarehouseChange = (event) => {
        setPickupWarehouse(event.target.value);
    }
    const handlePartnerIdChange = (event) => {
        setPartnerId(event.target.value);
    }

    const handleDateChange = (event) => {
        if(event.target.id === 'from'){
            setDateFrom(moment(event.target.value))
        } else if(event.target.id === 'to'){
            setDateTo(moment(event.target.value))
        }
    }

    useEffect(() => {
        setDateFrom(moment());
        setDateTo(moment());
        setPartnerId(null);
        setCreator(null);
        setDriverId(null);
    }, [searchType])

    return (
        <form className={classes.container} noValidate>
            {
                type &&
                type === 'fetch' &&
                <TextField
                    label={t('search_type')}
                    select
                    className={classes.textField}
                    value={searchType}
                    displayEmpty
                    variant="outlined"
                    onChange={(e)=>setSearchType(e.target.value)}
                >
                {
                    searchTypeList.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                            {type.text}
                        </MenuItem>
                    ))
                }
                </TextField>
            }
            {
                type &&
                (type === 'create' || (type === 'fetch' && searchType === 0)) &&
                <DateRangePicker
                    id="dateFrom"
                    className={classes.dateRangeRow}
                    fromDateValue={dateFrom}
                    toDateValue={dateTo}
                    textFieldStyle={{
                        minWidth: 236,
                        flex: 1
                    }}
                    handleDateChange={handleDateChange}
                />
            }
            {
                type &&
                (type === 'create' || (type === 'fetch' && searchType === 1)) &&
                <TextField
                    label={t('partner_id')}
                    select
                    className={classes.textField}
                    value={partnerId}
                    displayEmpty
                    variant="outlined"
                    onChange={handlePartnerIdChange}
                >
                    {
                        pickupPartners?.length > 0 &&
                        pickupPartners.map((partner) => (
                            <MenuItem key={partner.id} value={partner.id}>
                                {partner.name}
                            </MenuItem>
                        ))
                    }
                </TextField>
            }
            {
                type &&
                type === 'fetch' &&
                <div>
                {
                    searchType === 2 &&
                    <TextField
                        label={t("creator")}
                        className={classes.textField}
                        value={creator}
                        displayEmpty
                        variant="outlined"
                        onChange={handleCreatorChange}
                    />
                }
                {
                    searchType === 3 &&
                    <TextField
                        label={t("driver_id")}
                        className={classes.textField}
                        value={driverId}
                        displayEmpty
                        variant="outlined"
                        onChange={handleDriverIdChange}
                    />
                }
                </div>
            }
            <TextField
                label={t("pickup_warehouse")}
                select
                className={classes.textField}
                defaultValue={`-1`}
                value={pickupWarehouse}
                displayEmpty
                variant="outlined"
                onChange={handlePickupWarehouseChange}
            >
                <MenuItem value={`-1`}>{t('no_pickup_warehouse')}</MenuItem>
            {
                pickupWarehouses &&
                pickupWarehouses.length > 0 &&
                pickupWarehouses.map((warehouse) => (
                    <MenuItem key={warehouse.id} value={warehouse.id}>
                        {warehouse.name}
                    </MenuItem>
                ))
            }
            </TextField>
            <IconButton 
                color='primary' 
                onClick={() => 
                    type==='create' 
                    ? 
                    onSearchClick(dateFrom, dateTo, partnerId, pickupWarehouse)
                    :
                    onSearchClick(searchType, dateFrom, dateTo, creator, partnerId, driverId, pickupWarehouse)
                } 
                disabled={
                    (type === 'create' && !partnerId)
                    ||
                    (type === 'fetch' && pickupWarehouse === `-1`)
                }
            >
                <Search />
            </IconButton>
        </form>
    );
}

PickupSearch.defaultProps = {
    onSearchClick: ()=>{}
}